export default {
  from: {
    en: 'Gift from {name}',
  },
  label: {
    en: 'Gift subscription',
  },
  months: {
    en: '{months, plural, one {# month} other {# months}}',
  },
}
